import React from "react";

export type LabelProps = {
  children: React.ReactNode;
};

export const Label = ({ children }: LabelProps) => {
  return <div className="gpc__label">{children}</div>;
};

export default Label;
